import React from 'react';
import PropTypes from 'prop-types';

import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils';
import {
  Box, Button, Flex, Heading, Text, useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';

const HomepageBanner = ({
  backgroundImage,
  title,
  subtitle,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  ...props
}) => {
  const styles = useMultiStyleConfig('HomepageBanner', {});

  const defaultBackgroundImage = getAssetUrl('static/img/hero-banner-bg.png');
  const bgImage = backgroundImage || defaultBackgroundImage;

  return (
    <Box {...styles.container} {...props}>
      {/* Background Image */}
      <Box
        {...styles.backgroundImage}
        backgroundImage={`url('${bgImage}')`}
      />

      {/* Gradient Overlay */}
      <Box {...styles.overlay} />

      {/* Main Content */}
      <Flex {...styles.content}>
        <Box {...styles.saleInfo}>
          {/* Text Container */}
          <Box {...styles.textContainer}>
            <Heading {...styles.title}>
              {title || 'Summer sale ends soon'}
            </Heading>
            <Text {...styles.subtitle}>
              {subtitle || 'Up to 50% off selected designs'}
            </Text>
          </Box>

          {/* Button Group */}
          <Flex {...styles.buttonGroup}>
            {primaryButtonText && (
              <Button
                {...styles.primaryButton}
                onClick={onPrimaryClick}
              >
                {primaryButtonText}
              </Button>
            )}
            {secondaryButtonText && (
              <Button
                {...styles.secondaryButton}
                onClick={onSecondaryClick}
              >
                {secondaryButtonText}
              </Button>
            )}
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

HomepageBanner.displayName = 'HomepageBanner';

HomepageBanner.propTypes = {
  /**
   * Background image URL (optional)
   */
  backgroundImage: PropTypes.string,

  /**
   * Main title text
   */
  title: PropTypes.string,

  /**
   * Subtitle text
   */
  subtitle: PropTypes.string,

  /**
   * Primary button text
   */
  primaryButtonText: PropTypes.string,

  /**
   * Secondary button text
   */
  secondaryButtonText: PropTypes.string,

  /**
   * Primary button click handler
   */
  onPrimaryClick: PropTypes.func,

  /**
   * Secondary button click handler
   */
  onSecondaryClick: PropTypes.func,
};

export default HomepageBanner;
